<template>
  <div>
    <div class="wheel-wrapper">

      <div class="wheel-pointer"
           @click="!Object.keys(form.gift).length ? onClickRotate() : false">
        <v-icon :color="!Object.keys(form.gift).length ? 'secondary' :'grey lighten-2'"
                large>mdi-play-circle
        </v-icon>
      </div>

      <div :style="`transform: rotate(${wheelDeg}deg)`"
           class="wheel-bg">
        <div class="prize-list">
          <div v-for="(item,index) in prizeList"
               :key="index"
               class="prize-item-wrapper">
            <div :style="`transform: rotate(${(360/ prizeList.length) * index}deg)`"
                 class="prize-item">
              <div class="prize-name">
                {{ item.name }}
              </div>
              <v-avatar>
                <v-img :src="$baseUrl + item.image"></v-img>
              </v-avatar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    name: 'SpintowinGame',
    props: ['campaign', 'form'],
    data() {
        return {
            rolling: false,
            wheelDeg: 0
        }
    },
    computed: {
        prizeList() {
            return this.campaign.gifts
        }
    },
    methods: {
        onClickRotate() {
            if (this.rolling) {
                return
            }
            const result = Math.floor(Math.random() * this.campaign.gifts.length)
            this.roll(result)
        },
        roll(result) {
            this.rolling = true
            const {wheelDeg, prizeList} = this
            this.wheelDeg =
                wheelDeg -
                wheelDeg % 360 +
                6 * 360 +
                (360 - 360 / prizeList.length * result)
            setTimeout(() => {
                this.rolling = false
                this.form.gift = prizeList[result]
            }, 4500)
        }
    },

}
</script>

<style scoped>

.wheel-wrapper {
    width: 350px;
    height: 350px;
    position: relative;
    left: 50%;
    transform: translate(-50%, 0%);
}

.wheel-pointer {
    width: 60px;
    height: 60px;
    border-radius: 1000px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    line-height: 60px;
    z-index: 10;
    cursor: pointer;

    &::after {
        content: "";
        position: absolute;
        top: -32px;
        left: 50%;
        border-width: 0 8px 40px;
        border-style: solid;
        border-color: transparent transparent #fff;
        transform: translateX(-50%);
    }
}

.wheel-bg {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    overflow: hidden;
    transition: transform 4s ease-in-out;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.dev/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1013%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='rgba(111%2c 60%2c 251%2c 1)'%3e%3c/rect%3e%3cpath d='M1180.8786365233811 505.3677006671723L1299.5121567697488 409.30017016994725 1203.4446262725237 290.66664992357966 1084.811106026156 386.7341804208047z' fill='rgba(58%2c 125%2c 197%2c 0.4)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M356.42569165171767 22.690290338516032L214.1090691421171 95.03347154191783 329.8076133912451 173.07312502422505z' fill='rgba(58%2c 125%2c 197%2c 0.4)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M1462.018%2c282.126C1512.508%2c283.122%2c1559.308%2c257.961%2c1586.704%2c215.538C1616.825%2c168.894%2c1630.361%2c110.412%2c1604.705%2c61.171C1577.293%2c8.558%2c1521.251%2c-27.086%2c1462.018%2c-23.771C1407.104%2c-20.698%2c1369.004%2c26.466%2c1344.547%2c75.729C1323.091%2c118.947%2c1321.704%2c168.847%2c1345.571%2c210.782C1369.705%2c253.185%2c1413.237%2c281.164%2c1462.018%2c282.126' fill='rgba(58%2c 125%2c 197%2c 0.4)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M104.2022380001784 292.9656987395117L208.768214964313 348.56441492223894 264.3669311470402 243.99843795810435 159.80095418290563 188.39972177537712z' fill='rgba(58%2c 125%2c 197%2c 0.4)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M655.575%2c299.514C694.622%2c298.501%2c722.217%2c266.167%2c741.906%2c232.432C761.809%2c198.33%2c778.103%2c157.441%2c758.5%2c123.166C738.804%2c88.728%2c695.234%2c80.469%2c655.575%2c81.485C618.026%2c82.447%2c580.886%2c96.106%2c561.399%2c128.216C541.212%2c161.479%2c542.375%2c203.027%2c561.12%2c237.123C580.604%2c272.563%2c615.146%2c300.563%2c655.575%2c299.514' fill='rgba(58%2c 125%2c 197%2c 0.4)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M1031.9172492501266 404.2472360990393L902.5695222855566 459.15208872945533 957.4743749159726 588.4998156940253 1086.8221018805425 533.5949630636093z' fill='rgba(58%2c 125%2c 197%2c 0.4)' class='triangle-float3'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1013'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e");
    color: white;
    font-weight: 500;
}

.prize-list {
    width: 100%;
    height: 100%;
    position: relative;
    text-align: center;
}

.prize-item-wrapper {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 175px;
    height: 175px;
}

.prize-item {
    width: 100%;
    height: 100%;
    transform-origin: bottom;

    .prize-name {
        padding: 10px 0;
    }
}

</style>